/* global google: true */

import * as React from 'react';
import cx from 'classnames';

export interface IAddressAutocomplete {
  address_line1: string;
  lat: number;
  lng: number;
  locality: string;
  postal_code: string;

  /**
   * A state's name (eg. "New Mexico")
   */
  region: string;
}

type AddressAutocompleteProps = {
  className?: any;
  handlePlaceChanged: (address: IAddressAutocomplete) => void;
  handleReset?: () => void;
  placeholder?: string;
};

type AddressAutocompleteState = {
  error: string;
  hasSelectedAddress: boolean;
};

//import './AddressAutocomplete.scss';

class AddressAutocomplete extends React.Component<
  AddressAutocompleteProps,
  AddressAutocompleteState
> {
  private autocompleteField = React.createRef<HTMLInputElement>();

  state = {
    error: '',
    hasSelectedAddress: false,
  };

  componentDidMount() {
    const options = {
      types: ['address'],
      componentRestrictions: {
        country: 'us',
      },
    };

    // @ts-ignore
    const autocomplete = new google.maps.places.Autocomplete(
      this.autocompleteField.current,
      options
    );

    autocomplete.setFields(['address_components', 'geometry']);

    autocomplete.addListener('place_changed', () => {
      const components = {};
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        return this.setState({
          error: 'invalid_address',
        });
      }

      for (const component of place.address_components) {
        if (component.types[0] === 'administrative_area_level_1') {
          components[component.types[0]] = component.short_name;
        } else {
          components[component.types[0]] = component.long_name;
        }
      }

      const address = {
        address_line1: `${components['street_number'] || ''} ${
          components['route']
        }`,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        locality: components['locality'],
        postal_code: components['postal_code'],
        region: components['administrative_area_level_1']
          ? `${components['administrative_area_level_1']}`
          : null,
      };

      this.setState(
        {
          hasSelectedAddress: true,
        },
        () => {
          this.props.handlePlaceChanged(address);
        }
      );
    });
  }

  readonly handleChange = () => {
    if (this.state.error) {
      this.setState({
        error: '',
      });
    }
  };

  readonly resetSearch = e => {
    e.preventDefault();
    this.autocompleteField.current.value = '';
    this.props.handleReset && this.props.handleReset();
    this.setState({
      hasSelectedAddress: false,
    });
  };

  render() {
    const inputClasses = cx('form-control', {
      'has-error': this.state.error,
      [this.props.className]: this.props.className,
    });

    return (
      <div className="address-autocomplete">
        <input
          autoComplete="off"
          className={inputClasses}
          onChange={this.handleChange}
          placeholder={this.props.placeholder}
          ref={this.autocompleteField}
          readOnly={this.state.hasSelectedAddress}
          aria-label={this.props.placeholder}
          type="text"
        />
        {this.state.hasSelectedAddress && (
          <button
            className="address-autocomplete-clear"
            onClick={this.resetSearch}
          >
            &times;
          </button>
        )}
        {/* <div className="invalid-feedback">{errors[field.name]}</div> */}
      </div>
    );
  }
}

export default AddressAutocomplete;
